/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './meal.reducer';

export const MealDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const mealEntity = useAppSelector(state => state.meal.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mealDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.meal.detail.title">Meal</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.meal.id">Id</Translate>
            </span>
          </dt>
          <dd>{mealEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.meal.name">Name</Translate>
            </span>
          </dt>
          <dd>{mealEntity.name}</dd>
          <dt>
            <span id="tag">
              <Translate contentKey="tinyMedicRestApp.meal.tag">Tag</Translate>
            </span>
          </dt>
          <dd>{mealEntity.tag}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.meal.description">Description</Translate>
            </span>
          </dt>
          <dd>{mealEntity.description}</dd>
          <dt>
            <span id="feedType">
              <Translate contentKey="tinyMedicRestApp.meal.feedType">Feed Type</Translate>
            </span>
          </dt>
          <dd>{mealEntity.feedType}</dd>
          <dt>
            <span id="entralType">
              <Translate contentKey="tinyMedicRestApp.meal.entralType">Entral Type</Translate>
            </span>
          </dt>
          <dd>{mealEntity.entralType}</dd>
          <dt>
            <span id="mealType">
              <Translate contentKey="tinyMedicRestApp.meal.mealType">Meal Type</Translate>
            </span>
          </dt>
          <dd>{mealEntity.mealType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.meal.active">Active</Translate>
            </span>
          </dt>
          <dd>{mealEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.meal.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{mealEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.meal.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{mealEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.meal.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{mealEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.meal.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{mealEntity.timestampentry}</dd>
          <dt>
            <span id="weight">
              <Translate contentKey="tinyMedicRestApp.meal.weight">Weight</Translate>
            </span>
          </dt>
          <dd>{mealEntity.weight}</dd>
          <dt>
            <span id="wightUnits">
              <Translate contentKey="tinyMedicRestApp.meal.wightUnits">Wight Units</Translate>
            </span>
          </dt>
          <dd>{mealEntity.wightUnits}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.meal.price">Price</Translate>
            </span>
          </dt>
          <dd>{mealEntity.price}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.meal.createdBy">Created By</Translate>
          </dt>
          <dd>{mealEntity.createdBy ? mealEntity.createdBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.meal.modifiedMeal">Modified Meal</Translate>
          </dt>
          <dd>{mealEntity.modifiedMeal ? mealEntity.modifiedMeal.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.meal.hospital">Hospital</Translate>
          </dt>
          <dd>{mealEntity.hospital ? mealEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/meal" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/meal/${mealEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MealDetail;
